import React from 'react';
import { useAppSelector } from 'store';
import { StorePopupKeys } from 'store/slices/popups';

const PopupTrigger = ({
  popupKey,
  children
}: {
  popupKey: StorePopupKeys;
  children: React.ReactNode;
}) => {
  const popup = useAppSelector((s) => s.popups[popupKey]);

  if (!popup) return null;

  return <>{children}</>;
};

export default PopupTrigger;
